<template>
	<div class="mr-auto flex gap-16px pt-24px">
		<Checkbox v-model:checked="checked" />
		<p class="w-full">{{ paragraph }}</p>
	</div>
</template>

<script setup lang="ts">
import { ref, watch } from 'vue'
import Checkbox from '@/components/ui/checkbox/Checkbox.vue'

interface Props {
	modelValue?: boolean
	paragraph: string
}

const props = withDefaults(defineProps<Props>(), {
	modelValue: true,
})

const emit = defineEmits(['update:modelValue'])

const checked = ref(props.modelValue)

watch(checked, value => {
	emit('update:modelValue', value)
})
</script>
